import React, { Fragment, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from "react-redux";
import { addOtherUserDetails, clearErrors, userDetailsAction, } from "../../redux/actions/userActions";
import Loader from '../loader/loader';

import { ADD_DETAILS_RESET } from '../../redux/constants/userConstant';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

import store from "../../store"
import BasicInfo from '../login/Additionalinformation/BasicInfo';
import Address from './Address';
import BankDetails from '../login/Additionalinformation/BankDetails';
import Verification from '../login/Additionalinformation/Verification';



const OtherUserDetails = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { loading, error, message } = useSelector((state) => state.inviteUser);

  const { loading: userLoading, error: userError, user } = useSelector((state) => state.userDetails)




  const [searchParams] = useSearchParams();
  const userID = searchParams.get("user_id");




  const [counteryCode, setCounteryCode] = useState("")
  const [phone_number, setPhoneNumber] = useState("")
  const [avatar_url, setAvatar_url] = useState()
  const [avatarPreview, setAvatarPreview] = useState()
  const [fb_link, setFb_link] = useState()
  const [cnic_front_url, setCnic_front_url] = useState()
  const [cnic_front_preview, setCnic_front_preview] = useState()
  const [cnic_back_url, setCnic_back_url] = useState()
  const [cnic_back_preview, setCnic_back_preview] = useState()
  const [cnic_number, setcnic_number] = useState("")
  const [street_address, setstreet_address] = useState("")
  const [city, setcity] = useState("")
  const [state, setstate] = useState("")
  const [bank_name, setbank_name] = useState("")
  const [account_title, setaccount_title] = useState("")
  const [account_number, setaccount_number] = useState("")
  const [basicInfo, setBasicInfo] = useState(false)
  const [address, setAddress] = useState(false)
  const [bankDetails, setBankDetails] = useState(false)
  const [verification, setVerification] = useState(false)



  const handleSubmit = async (e) => {
    e.preventDefault()




    if (!counteryCode) return toast.error("Please enter country code");
    if (!phone_number) return toast.error("Please enter Whatsapp number");
    if (!avatar_url && !avatarPreview) return toast.error("Please upload avatar");
    if (!cnic_front_url && !cnic_front_preview) return toast.error("Please upload front side of cnic");
    if (!cnic_back_url && !cnic_back_preview) return toast.error("Please upload back side of cnic");

    if (!street_address) return toast.error("Please enter street address");
    if (!city) return toast.error("Please enter city");
    if (!state) return toast.error("Please enter state");
    if (!bank_name) return toast.error("Please enter bank name");
    if (!account_title) return toast.error("Please enter account title");
    if (!account_number) return toast.error("Please enter account number");
    if (!cnic_number) return toast.error("Please enter CNIC number");


    try {



      const files = [
        avatar_url,
        cnic_front_url,
        cnic_back_url
      ].filter(Boolean);

      const total = files.length;


      // ✅ START ONCE
      store.dispatch({ type: "UPLOAD_START" });

      let uploaded = [];

      for (let i = 0; i < files.length; i++) {



        const url = await uploadToCloudinary(
          files[i],
          "avatars",
          i + 1,
          total
        );

        uploaded.push(url);
      }

      const [profileImageURL, CnicFrontURL, CnicBackURL] = uploaded;





      const data = {

        countryCode: counteryCode,
        phone_number,
        avatar_url: profileImageURL,
        fb_link,
        cnic_front_url: CnicFrontURL,
        cnic_back_url: CnicBackURL,
        street_address,
        city,
        state,
        bank_name,
        account_title,
        account_number,
        cnic_number,
      };


      store.dispatch({ type: "UPLOAD_END" });



      dispatch(addOtherUserDetails(data, userID))


    } catch (err) {


      store.dispatch({ type: "UPLOAD_RESET" });


      toast.error("Images upload failed. Please Check your Internet Connection and then try again. ");
    }




  }



  useEffect(() => {
    if (message) {
      toast.success(message);
      dispatch({ type: ADD_DETAILS_RESET })
      navigate(`/dashboard/user-details?user_id=${userID}`)
    }
    if (error || userError) {
      toast.error(error || userError);
      dispatch(clearErrors());
    }
  }, [error, message, navigate, dispatch, userID, userError]);




  useEffect(() => {

    document.title = 'UPDATE USER DETAILS'

  }, [])



  useEffect(() => {

    if (userID) {
      dispatch(userDetailsAction(userID))
    }


  }, [dispatch, userID])



  const handleFileChange = (setImage, setPreview) => (e) => {
    const file = e.target.files[0];

    if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    } else {
      alert("Only PNG and JPG files are allowed!");
    }
  };



  useEffect(() => {
    if (user) {
      setCounteryCode(user.country_code || "")
      setPhoneNumber(user.phone_number || "")
      setAvatarPreview(user.avatar_url || "")
      setFb_link(user.fb_link || "")
      setCnic_front_preview(user.cnic_front_url || "")
      setCnic_back_preview(user.cnic_back_url || "")

      setstreet_address(user.street_address || "")
      setcity(user.city || "")
      setstate(user.state || "")
      setbank_name(user.bank_name || "")
      setaccount_title(user.account_title || "")
      setaccount_number(user.account_number || "")
      setcnic_number(user.cnic_number || "")


    }
  }, [user])






  useEffect(() => {

    if (counteryCode && phone_number && avatarPreview) {
      setBasicInfo(true)
    } else {
      setBasicInfo(false)
    }

    if (street_address && city && state) {
      setAddress(true)
    } else {
      setAddress(false)
    }

    if (bank_name && account_title && account_number) {
      setBankDetails(true)
    } else {
      setBankDetails(false)
    }

    if (cnic_number && cnic_front_preview && cnic_back_preview) {
      setVerification(true)
    } else {
      setVerification(false)
    }


  }, [counteryCode, phone_number, avatarPreview, street_address, city, state, bank_name, account_title, account_number, cnic_number, cnic_front_preview, cnic_back_preview])




  return (
    <Fragment>
      {(loading || userLoading) ? <Loader /> :
        <>
          <section className=" flex items-center justify-center md:p-[2vmax] signPage">
            <div className="flex flex-col justify-between items-center  w-[100%] mt-[0vmax]">
              <div className="w-[100%]  flex-center flex-col">
                <h1 className='text-[3.2vmax] font-3 font-[900] leading-[3.6vmax]' >
                  Update User &nbsp;
                  <span className='customBG-4' >Profile.</span>
                </h1>
                <br />
                <br />
              </div>
              <div className="flex-center w-[100%] bg-white customBG-5 rounded-[2vmax]">
                <div className="flex w-full p-[2vmax]">

                  <form className="flex flex-col justify-center items-center  w-[100%]  " onSubmit={handleSubmit}>
                   <div className="grid grid-cols-[1fr_1.5fr_1.5fr_1fr] w-full  lg:w-[80%] mx-auto">
                      <div className=" flex justify-between items-start ">
                        <div className="w-[60%]  flex-center  flex-col relative">
                          <div className={`w-[2.5vmax] h-[2.5vmax] rounded-full border-[0.15vmax] 
                          ${basicInfo ? 'bg-[image:var(--gradient-1)] border-none' : 'border-gray-300'}
                              flex-center ${basicInfo ? 'text-white' : 'text-gray-500'} font-bold text-[1.3vmax]`}>
                            1
                          </div>
                          <h3 className='text-center text-[0.9vmax] font-bold mt-[0.5vmax]' >
                            Personal Info
                          </h3>
                          <p className='text-[0.8vmax] text-gray-600 font-[500] mt-[0.3vmax] text-center' >
                            Basic info
                          </p>
                        </div>
                        <div className={`${basicInfo ? 'bg-[var(--color-3)]' : 'bg-gray-300'} w-[40%] h-[0.2vmax] mt-[1.25vmax]`}></div>
                      </div>
                      <div className=" flex justify-between items-start ">
                        <div className={`${address ? 'bg-[var(--color-3)]' : 'bg-gray-300'} w-[30%] h-[0.2vmax] mt-[1.25vmax]`}></div>

                        <div className="w-[40%]  flex-center  flex-col relative">
                          <div className={`w-[2.5vmax] h-[2.5vmax] rounded-full border-[0.15vmax] 
                          ${address ? 'bg-[image:var(--gradient-1)] border-none' : 'border-gray-300'}
                              flex-center ${address ? 'text-white' : 'text-gray-500'}  font-bold text-[1.3vmax]`}>
                            2
                          </div>
                          <h3 className='text-center text-[0.9vmax] font-bold mt-[0.5vmax]' >
                            Address
                          </h3>
                          <p className='text-[0.8vmax] text-gray-600 font-[500] mt-[0.3vmax] text-center' >
                            Your Location
                          </p>
                        </div>
                        <div className={`${address ? 'bg-[var(--color-3)]' : 'bg-gray-300'} w-[30%] h-[0.2vmax] mt-[1.25vmax]`}></div>
                      </div>
                      <div className=" flex justify-between items-start ">
                        <div className={`${bankDetails ? 'bg-[var(--color-3)]' : 'bg-gray-300'} w-[30%] h-[0.2vmax] mt-[1.25vmax]`}></div>

                        <div className="w-[40%]  flex-center  flex-col relative">
                          <div className={`w-[2.5vmax] h-[2.5vmax] rounded-full border-[0.15vmax] 
                          ${bankDetails ? 'bg-[image:var(--gradient-1)] border-none' : 'border-gray-300'}
                              flex-center ${bankDetails ? 'text-white' : 'text-gray-500'} font-bold text-[1.3vmax]`}>
                            3
                          </div>
                          <h3 className='text-center text-[0.9vmax] font-bold mt-[0.5vmax]' >
                            Bank Details
                          </h3>
                          <p className='text-[0.8vmax] text-gray-600 font-[500] mt-[0.3vmax] text-center' >
                            Account Info
                          </p>
                        </div>
                        <div className={`${bankDetails ? 'bg-[var(--color-3)]' : 'bg-gray-300'} w-[30%] h-[0.2vmax] mt-[1.25vmax]`}></div>
                      </div>
                      <div className=" flex justify-between items-start ">
                        <div className={`${verification ? 'bg-[var(--color-3)]' : 'bg-gray-300'} w-[40%] h-[0.2vmax] mt-[1.25vmax]`}></div>

                        <div className="w-[60%]  flex-center  flex-col relative">
                          <div className={`w-[2.5vmax] h-[2.5vmax] rounded-full border-[0.15vmax] 
                          ${verification ? 'bg-[image:var(--gradient-1)] border-none' : 'border-gray-300'}
                              flex-center ${verification ? 'text-white' : 'text-gray-500'} font-bold text-[1.3vmax]`}>
                            4
                          </div>
                          <h3 className='text-center text-[0.9vmax] font-bold mt-[0.5vmax]' >
                            Verification
                          </h3>
                          <p className='text-[0.8vmax] text-gray-600 font-[500] mt-[0.3vmax] text-center' >
                            Cnic Verification
                          </p>
                        </div>
                      </div>
                    </div>
                    <br />
                    <br />
                      <div className="grid grid-cols-[1fr] lg:grid-cols-[1fr_1fr] gap-[3vmax] lg:gap-[1vmax] w-full">
                      <BasicInfo
                        counteryCode={counteryCode}
                        phone_number={phone_number}
                        fb_link={fb_link}
                        avatar_url={avatar_url}
                        avatarPreview={avatarPreview}
                        setCounteryCode={setCounteryCode}
                        setPhoneNumber={setPhoneNumber}
                        setFb_link={setFb_link}
                        setAvatar_url={setAvatar_url}
                        setAvatarPreview={setAvatarPreview}
                        handleFileChange={handleFileChange}
                      />
                      <Address
                        street_address={street_address}
                        city={city}
                        state={state}
                        setstreet_address={setstreet_address}
                        setcity={setcity}
                        setstate={setstate}
                      />

                      <BankDetails
                        bank_name={bank_name}
                        account_title={account_title}
                        account_number={account_number}
                        setbank_name={setbank_name}
                        setaccount_title={setaccount_title}
                        setaccount_number={setaccount_number}

                      />
                      <Verification

                        cnic_number={cnic_number}
                        cnic_front_url={cnic_front_url}
                        cnic_back_url={cnic_back_url}
                        cnic_front_preview={cnic_front_preview}
                        cnic_back_preview={cnic_back_preview}
                        setcnic_number={setcnic_number}
                        setCnic_front_url={setCnic_front_url}
                        setCnic_back_url={setCnic_back_url}
                        setCnic_front_preview={setCnic_front_preview}
                        setCnic_back_preview={setCnic_back_preview}
                        handleFileChange={handleFileChange}

                      />
                    </div>
                    <br />
                    <br />



                    <div className="w-[100%] text-center">
                      <button
                        type='submit'
                        className={`bg-[image:var(--gradient-2)] my-[2vmax] py-[0.8vmax] rounded-xl text-white font-bold shadow-2 block text-[1.8vmax] lg:text-[1.1vmax] px-[2vmax] w-fit mx-auto hover:scale-[0.95`}
                      >
                        Save
                      </button>
                    </div>



                  </form>
                </div>
              </div>
            </div>
          </section>
        </>
      }

    </Fragment >

  )
}

export default OtherUserDetails